module.exports = __webpack_public_path__ + "static/shareAir3BG-fc230fe8ac27b902d425e6e8ab99f5b5.png";